<template>
  <div class="zac-pending pa-2">
    <div class="d-flex align-center mb-1">
      <span class="subheading"><b>Pending ZIPs</b></span>
      <v-chip x-small class="ml-2" :color="pendingCount ? 'orange' : 'grey lighten-1'" text-color="white">{{ pendingCount }}</v-chip>
      <v-tooltip bottom>
        <v-icon slot="activator" small class="ml-1" color="grey">help_outline</v-icon>
        <span>Click ZIP polygons on the map, or paste a comma-separated ZIP list here.</span>
      </v-tooltip>
    </div>
    <v-textarea outline dense rows="3" hide-details
      :value="value"
      @input="$emit('input', $event)"
      placeholder="48104, 48105, ..."></v-textarea>
    <div class="caption grey--text mt-1">click on map OR paste here</div>
    <v-autocomplete dense hide-details
      :items="reps"
      :item-text="repLabel"
      return-object
      :value="selectedRep"
      @input="$emit('update:selectedRep', $event)"
      label="Reassign to"
      class="mt-2"></v-autocomplete>
    <div class="d-flex mt-2 zac-pending-actions">
      <v-btn small color="primary" class="zac-pending-reassign"
        :disabled="!pendingCount || !selectedRep"
        @click="$emit('assign', selectedRep)">
        Reassign {{ pendingCount }} ZIPs
      </v-btn>
      <v-btn small outline class="ml-1"
        :disabled="!pendingCount"
        title="Flash pending ZIPs on map for 3 seconds"
        @click="$emit('highlight-pending')">
        Highlight on map
      </v-btn>
    </div>
  </div>
</template>

<script>
import { parseZips } from './parseZips'
export default {
  props: {
    value: { type: String, default: '' },
    reps: { type: Array, default: () => [] },
    selectedRep: { type: Object, default: null },
  },
  computed: {
    pendingCount () { return parseZips(this.value).length },
  },
  methods: {
    repLabel (trz) { return `${trz.repName} (${trz.territoryId})` },
  },
}
</script>

<style scoped>
.zac-pending { background: #fff8e1; border-bottom: 1px solid #ffe082; }
.zac-pending-actions  { gap: 4px; }
.zac-pending-reassign { flex: 1; }
</style>
